import { Tooltip } from 'chart.js/auto';

const horizontalMiddlePositioner = function (items) {
  return {
    x: this.chart.chartArea.width / 2 + this.chart.chartArea.left,
    y: items[0].element.tooltipPosition(true).y,
  };
};

const verticalMiddlePositioner = function (items) {
  return {
    x: items[0].element.tooltipPosition(true).x,
    y: this.chart.chartArea.height / 2 + this.chart.chartArea.top,
  };
};

Tooltip.positioners.middle = function (items, eventPosition) {
  if (!items.length) return false;
  const isHorizontalChart = this.chart.options.indexAxis === 'y';
  if (isHorizontalChart) return horizontalMiddlePositioner.call(this, items, eventPosition);
  return verticalMiddlePositioner.call(this, items, eventPosition);
};
